import { Component, input } from '@angular/core';
import { ViewModelProperty } from '../../models';
import { VMPLabelComponent } from '../vmp-label/vmp-label.component';

@Component({
  selector: 'ldw-vmp-form-group-item',
  templateUrl: './vmp-form-group-item.component.html',
  styleUrls: ['./vmp-form-group-item.component.css'],
  imports: [VMPLabelComponent]
})
export class VMPFormGroupItemComponent {
  readonly vmp = input<ViewModelProperty>();
  readonly captionWidth = input(100);
  readonly captionVisible = input(true);

  getItemWidth(): string {
    return 'width: ' + this.captionWidth() + 'px;';
  }
}
